<template>
  <div class="content--sinoreg">
    <header-blue>
      SIPET - Sitema de Peticionamento Eletrônico
    </header-blue>

    <div class="px-2 py-3 d-inline-flex align-items-top">
      <div class="col-5 form-group m-0 p-0 mr-2">
        <label for="mes"
               class="label seade_label">Mês</label>
        <select id="mes"
                v-model="form.mes"
                v-validate="'required'"
                name="mes_seade"
                class="custom-select custom-select-sm"
                :class="{'is-invalid': errors.has('mes_seade')}"
                @input="changeData">
          <option :value="null">
            Selecione
          </option>
          <option v-for="(month, index) in meses"
                  :key="index"
                  :value="month.value">
            {{ month.text | firstCapitalize }}
          </option>
        </select>
        <span v-if="errors.has('mes_seade')"
              class="invalid-feedback">
          {{ errors.first('mes_seade') }}
        </span>
      </div>
      <div class="col-5 form-group m-0 p-0">
        <label for="ano"
               class="label">Ano</label>
        <select id="mes"
                v-model="form.ano"
                v-validate="'required'"
                name="ano_seade"
                class="custom-select custom-select-sm"
                :class="{'is-invalid': errors.has('ano_seade')}"
                @input="changeData">
          <option :value="null">
            Selecione
          </option>
          <option v-for="(year, index) in years"
                  :key="index"
                  :value="year">
            {{ year }}
          </option>
        </select>
        <span v-if="errors.has('ano_seade')"
              class="invalid-feedback">
          {{ form.ano ? errors.first('ano_seade') : "Campo obrigatório" }}
        </span>
      </div>
      <div class="pt-3">
        <button class="btn btn-outline-primary btn-sm ml-2 mt-2 px-3"
                @click="getList()">
          Listar
        </button>
      </div>
    </div>
    <hr class="mt-2 mb-0">
    <div>
      <div class="row">
        <div class="col text-right mr-3 p-3">
          <b-button size="sm"
                    @click="getPdf()">
            <icon-svg icon="print"
                      class="icon--xs icons--white" />
            Imprimir
          </b-button>
          <b-button size="sm"
                    class="ml-3"
                    @click="exportCsv">
            <icon-svg icon="fileDownload"
                      class="icon--xs icons--white" />
            Exportar
          </b-button>
        </div>
      </div>


      <div v-if="relatorio !== null"
           class="col-12 overflow-auto">
        <div class="d-inline-flex listagem_header mt-1 pt-2 pr-0 pl-0 mr-0 ml-0">
          <div class="col_cpf justify-content-center">
            Cpf
          </div>
          <div class="col_nome justify-content-center ">
            Nome
          </div>
          <div class="col_data_obito justify-content-center">
            Data do óbito
          </div>
          <div class="col_estado_civil justify-content-center">
            Estado civil
          </div>
          <div class="col_cidade justify-content-center">
            Cidade
          </div>
          <div class="col_uf justify-content-center">
            UF
          </div>
          <div class="col_deixa_filhos justify-content-center">
            Deixa filhos?
          </div>
          <div class="col_deixa_bens justify-content-center">
            Deixa bens?
          </div>
          <div class="col_matricula justify-content-center">
            Matrícula do registo
          </div>
        </div>
        <div class="listagem_relatorio">
          <div v-for="(item, index) in relatorio.data"
               :key="index"
               class="d-inline-flex listagem_relatorio_itens mt-1 pr-0 pl-0 mr-0 ml-0">
            <div class="col_cpf justify-content-left text-nowrap">
              {{ item.pessoa.cpf | cpf }}
            </div>
            <div class="col_nome justify-content-left d-inline-block text-capitalize">
              {{ item.pessoa.nome ? item.pessoa.nome.toLocaleLowerCase() : '' }}
            </div>
            <div class="col_data_obito justify-content-center">
              {{ item.data_ocorrido ? dataFormat(item.data_ocorrido) : '' }}
            </div>
            <div class="col_estado_civil justify-content-center text-capitalize">
              {{ item.pessoa.estado_civil ? item.pessoa.estado_civil.toLocaleLowerCase() : '' }}
            </div>
            <div class="col_cidade justify-content-center">
              {{ item.pessoa.endereco && item.pessoa.endereco.cidade ? item.pessoa.endereco.cidade : '' }}
            </div>
            <div class="col_uf justify-content-center">
              {{ item.pessoa.endereco && item.pessoa.endereco.uf ? item.pessoa.endereco.uf : '' }}
            </div>
            <div class="col_deixa_filhos justify-content-center">
              {{ item.obito.deixa_filhos ? 'Sim' : 'Não' }}
            </div>
            <div class="col_deixa_bens justify-content-center">
              {{ item.obito.deixa_bens ? 'Sim' : 'Não' }}
            </div>
            <div class="col_matricula justify-content-center text-break">
              {{ item.matricula ? item.matricula : '' }}
            </div>
          </div>
        </div>
      </div>

      <div v-if="relatorio && relatorio.total > relatorio.perPage"
           class="row mt-3 mb-3 col-10 paginate d-inline-flex justify-content-center align-items-center">
        <p class="paginate_text small d-inline-block mt-0"
           style="padding-left: 20.5%">
          Página
        </p>

        <button class="paginate_btn btn btn-sm btn-link p-1 ml-1"
                :class="{ 'inactive': (Number(page) === 1) }"
                :disabled="(Number(page) === 1)"
                type="button"
                title="Página anterior"
                @click="paginaAnterior()">
          <svg class="paginate_icon icon--xxs"
               role="presentation">
            <use :xlink:href="'#' + arrow_left.id" />
          </svg>
        </button>

        <p class="paginate_text small d-inline-block mt-0">
          <select v-model="page"
                  class="form-control form-control-sm"
                  @change="selecionaPagina(page)">
            <option v-for="(value, index) in lastPage"
                    :key="`option_paginate_dashboard_${ index }_${ _uid }`">
              {{ value }}
            </option>
          </select>
        </p>

        <button class="paginate_btn btn btn-sm btn-link p-1 ml-1"
                :class="{ 'inactive': Number(page) === lastPage }"
                :disabled="(Number(page) === lastPage)"
                type="button"
                title="Próxima página"
                @click="proximaPagina()">
          <svg class="paginate_icon icon--xxs"
               role="presentation">
            <use :xlink:href="'#' + arrow_right.id" />
          </svg>
        </button>

        <p class="paginate_text small d-inline-block mt-0">
          {{ `de ${lastPage}` }}
        </p>
      </div>

      <object v-if="pdf != null"
              class="document-preview embed-responsive"
              :data="`${ pdf }`"
              type="application/pdf">
        <p>Seu browser não suporta arquivos pdf diretamente ou este arquivo não existe. Você pode tentar efetuar o download clicando.</p>
      </object>
    </div>
  </div>
</template>

<script>
  /* services */
  import RelatorioSipetService from "@/services/Relatorios/RelatorioSipetService"
  import arrow_left from '@/assets/icons/arrow-left.svg?sprite'
  import arrow_right from '@/assets/icons/arrow-right.svg?sprite'


  /* components */
  import HeaderBlue from "@/components/SofiaRei/Headers/HeaderBlue"

  /* others */
  import moment from "moment"
  import CartorioService from "@/services/CartorioService"

  export default {
    name: "Sipet",
    components: {
      HeaderBlue
    },
    data () {
      return {
        pdf: null,
        form: {
          mes: null,
          ano: null
        },
        months: [],
        years: [],
        meses: [
          {text: 'janeiro', value: "01"},
          {text: 'fevereiro', value: "02"},
          {text: 'março', value: "03"},
          {text: 'abril', value: "04"},
          {text: 'maio', value: "05"},
          {text: 'junho', value: "06"},
          {text: 'julho', value: "07"},
          {text: 'agosto', value: "08"},
          {text: 'setembro', value: "09"},
          {text: 'outubro', value: "10"},
          {text: 'novembro', value: "11"},
          {text: 'dezembro', value: "12"},
        ],
        relatorio: null,
        urlPdf: null,
        page: 1,
        lastPage: 1,
        perPage: 10,
        arrow_left,
        arrow_right,
        cartorio: {},
        qtdeTotalItens: null,
        changeMonthOrYear: false
      }
    },
    async created () {
      const { data } = await CartorioService.getCartorioRei(this.$store.state.auth.cartorio_id)
      this.cartorio = data
    },
    mounted () {
      this.getYears()
    },
    methods: {
      async listar () {
        this.changeMonthOrYear = false
        this.$validator.validateAll().then(async status => {
          if (!this.form.mes || !this.form.ano) return

          loader({ active: true })

          if (status) {
            const payload = {
              page: this.page,
              perPage: this.perPage,
              mes: this.form.mes,
              ano: this.form.ano,
              cartorio_id: this.cartorio.cartorio_id
            }

            try {
              const relatorio = await RelatorioSipetService.getItensRelatorio( payload )

              if (relatorio.data.total > 0) {
                this.relatorio = relatorio.data
                this.qtdeTotalItens = relatorio.data.total

                if (this.qtdeTotalItens > this.perPage) {
                  this.lastPage = Math.ceil(this.qtdeTotalItens / this.perPage)
                }
              } else {
                this.relatorio = null
                displayMessage('error', 'Atenção', 'Não há registros na data informada.')
              }
            } finally {
              loader({ active: false })
            }
          }
        })
      },
      changeData () {
        this.changeMonthOrYear = true
      },
      getList () {
        this.page = 1
        this.listar()
      },
      getYears () {
        const year = moment().year()

        for (let ano = year; ano >= 1900; ano--) {
          this.years.push(ano)
        }
      },
      dataFormat (data) {
        return moment(data).format('DD/MM/YYYY')
      },
      paginaAnterior () {
        this.page = Number(this.page) - 1

        return this.listar()
      },

      selecionaPagina (page = 1) {
        this.page = Number(page)

        return this.listar()
      },

      proximaPagina () {
        this.page = Number(this.page) + 1

        return this.listar()
      },
      getPdf () {
        this.$validator.validateAll().then(async status => {
          if (!this.form.mes || !this.form.ano) return
          loader({text: 'Gerando relatorio', active: true})

          if (this.changeMonthOrYear) {
            this.relatorio = null
            this.changeMonthOrYear = false
          }

          if (status) {
            const payload = {
              page: 1,
              perPage: false,
              mes: this.form.mes,
              ano: this.form.ano,
              cartorio_id: this.cartorio.cartorio_id
            }

            try {
              const url = await RelatorioSipetService.getPdfRelatorio( payload )

              if (url.statusText !== 'No Content') {
                let blob = new Blob([url.data], { type: 'application/pdf' })
                this.urlPdf = window.URL.createObjectURL(blob)
                window.open(this.urlPdf)
              } else {
                this.relatorio = null
                displayMessage('error', 'Atenção', 'Não há registros na data informada.')
              }
            } catch (e) {
              console.error(e)
              displayMessage('Erro ao gerar relatório: ' + e.response.data.message)

            } finally {
              loader({ active: false })
            }
          }
        })
      },
      async convertToCsvString (data) {
        const keys = Object.keys(data[0])
        const rows = ['CPF do(a) falecido(a);' +
          'Nome do falecido;' +
          'Data do óbito;' +
          'Estado divil do ´´de cujus``;' +
          'Endereço do ´´de cujus`` (logradouro, número, CEP e complemento);' +
          'Cidade;' +
          'UF;' +
          'Deixa filhos (SIM/NÃO);' +
          'Deixa bens (SIM/NÃO);' +
          'Nº da certidão de óbito (opcional);' +
          'Observações (opcional)']

        for (const obj of data) {
          const values = keys.map(key => {
            const value = obj[key]
            if (typeof value === "string" && value.includes(";")) {
              return `"${value}"`
            } else {
              return value
            }
          })
          rows.push(values.join(";"))
        }

        return rows.join("\n")
      },
      async exportCsv () {
        this.$validator.validateAll().then(async resp => {
          if (!this.form.mes || !this.form.ano) return
          loader({text: 'Exportando em excel', active: true})

          if (this.changeMonthOrYear) {
            this.relatorio = null
            this.changeMonthOrYear = false
          }

          if (resp) {
            moment.locale('pt-br')
            const payload = {
              page: 1,
              perPage: false,
              mes: this.form.mes,
              ano: this.form.ano,
              cartorio_id: this.cartorio.cartorio_id
            }

            try {
              const resCsv = await RelatorioSipetService.exportCsvRelatorio( payload )

              if (resCsv && !!resCsv.data.length) {
                const csvString = await this.convertToCsvString(resCsv.data)
                const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" })
                const link = document.createElement('a')

                link.href = window.URL.createObjectURL(blob)
                link.setAttribute('download', `Sitema de Peticionamento Eletrônico - ` + moment(new Date()).format('LL') + '.csv')
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
              } else {
                this.relatorio = null
                displayMessage('error', 'Atenção', 'Não há registros na data informada.')
              }
            } catch (e) {
              console.error(e)
              displayMessage('Erro ao exportar relatório: ' + e.response.data.message)
            } finally {
              loader({ active: false, text: '' })
            }
          }
        })
      }
    }
  }

</script>

<style scoped lang="scss">
@import '../../../scss/_utilities/_exports';
.document-preview {
  height: 500px !important;
}

.listagem_header {
  background: #01bfa5;
  color: #000;
  font-size: 16px;
  font-weight: bold;
  border-radius: 3px 0;
  width: 1144px;
}
.listagem_relatorio {
  border: 1px solid #696969;
  border-radius: 3px;
  border-bottom: none;
  width: 1144px;
}
.listagem_relatorio_itens {
  border-bottom: 1px solid #696969;
  font-size: 14px;
  width: 1144px;
}

.col_cpf {
  width: 100px;
  padding-left: 5px;
}

.col_nome {
  width: 270px;
  padding-left: 25px;
}

.col_data_obito {
  width: 90px;
  padding-left: 5px;
}

.col_estado_civil {
  width: 85px;
  padding-left: 8px;
}

.col_cidade {
  width: 230px;
  padding-left: 5px;
}

.col_uf {
  width: 60px;
  padding-left: 5px;
}

.col_deixa_filhos {
  width: 60px;
  padding-left: 5px;
}

.col_deixa_bens {
  width: 60px;
  padding-left: 5px;
}

.col_matricula {
  width: 175px;
  padding-left: 5px;
}

.paginate {
  &_text {
    font-size: pxToRem(14);
    font-weight: 500;
    margin-bottom: 0;
  }

  &_btn {
    &.inactive {
      .paginate_icon {
        fill: $color-gray;
      }
    }
  }
}

</style>
